(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-update-your-bet-button-info.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/requests/sbtech-update-your-bet-button-info.js');
"use strict";


const {
  yourbet
} = svs.sportsbook.sbtech_api_impl;
svs.sportsbook.sbtech_api_impl.fns.requests.sbtech_updateYourBetButtonInfo = () => _ref => {
  let {
    count,
    odds,
    isMinItemsReached,
    isMaxItemsReached
  } = _ref;
  yourbet.updateCount(count, odds, isMinItemsReached, isMaxItemsReached);
};

 })(window);